module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-au-f2f37de2.webp";